import { render, staticRenderFns } from "./BlockedOrder.vue?vue&type=template&id=5ef26c5e&"
import script from "./BlockedOrder.vue?vue&type=script&lang=js&"
export * from "./BlockedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports